/** Dashboard streak copy, kept apart from ActivityCard so it tests without the API client. */

export const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? '' : 's'}`;

/** Days are UTC, so the streak's deadline is the next UTC midnight, shown in
 *  the viewer's own clock. */
export const streakDeadline = (now: Date = new Date()) =>
    new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1))
        .toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

export const streakMessage = (data: { current_streak: number; longest_streak: number; learned_today: boolean }, deadline: string) => {
    const { current_streak: current, longest_streak: longest, learned_today: learnedToday } = data;
    if (current > 0 && learnedToday) {
        return `Today counts. Come back tomorrow to make it ${plural(current + 1, 'day')}.`;
    }
    if (current > 0) {
        return `Learn something before ${deadline} to keep your ${current}-day streak alive.`;
    }
    if (longest > 0) {
        return `Your best run is ${plural(longest, 'day')}. Learn something today to start a new streak.`;
    }
    return 'Run a challenge or answer a theory question to start your first streak.';
};
